import * as actions from "../action.constants";

const initialState = {
  isLoading: false,
  siteList: [],
  notifyError: false,
  organization: {},
  organizationAddress: {},
  organizationImages: {},
};

const storeOrganization = (state, action) => {
  return {...state, organization: action.payload, isLoading: false};
};

const applicationError = (state, action) => {
  return {...state, notifyError: action.notifyError};
};

const storeOrgAddress = (state, action) => {
  return {
    ...state,
    organizationAddress: action.payload,
  };
};

const storeOrganizationImages = (state, action) => {
  return {
    ...state,
    organizationImages: action.payload,
  };
};

const handlers = {
  [actions.STORE_ORGANIZATION]: storeOrganization,
  [actions.APPLICATION_ERROR]: applicationError,
  [actions.STORE_ORGANIZATION_ADDRESS]: storeOrgAddress,
  [actions.STORE_ORGANIZATION_IMAGES]: storeOrganizationImages,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
